export const en = {
  'branches.switch': 'Branch',
  'branches.all': 'All branches',
  'branches.tab': 'Branches',
  'branches.title': 'Branches',
  'branches.description':
    'The places your gym runs. Members, plans and balances are shared; doors, desks and the bar belong to a branch.',
  'branches.name': 'Name',
  'branches.nameGeorgian': 'Name in Georgian',
  'branches.nameGeorgianHint': 'The Georgian website shows it. Left empty, it shows the name.',
  'branches.address': 'Address',
  'branches.city': 'City',
  'branches.phone': 'Phone',
  'branches.sortOrder': 'Order',
  'branches.readerCount.one': '{count} reader',
  'branches.readerCount.other': '{count} readers',
  'branches.primary': 'Primary',
  'branches.archived': 'Archived',
  'branches.add': 'Add a branch',
  'branches.addTitle': 'New branch',
  'branches.editTitle': 'Edit {name}',
  'branches.save': 'Save',
  'branches.makePrimary': 'Make primary',
  'branches.archive': 'Archive',
  'branches.restore': 'Restore',
  'branches.showArchived': 'Show archived branches',
  'branches.created': 'Branch added',
  'branches.updated': 'Branch saved',
  'branches.primaryUpdated': 'Primary branch changed',
  'branches.archivedDone': 'Branch archived',
  'branches.restoredDone': 'Branch restored',
  'branches.archiveTitle': 'Archive {name}?',
  'branches.archiveBody':
    'It disappears from the branch switcher and from new choices. Its history stays.',
  'branches.primaryHint':
    'The primary branch is where anything without a branch belongs. It cannot be archived.',
  'branches.single': 'Your gym has one branch. Add another when you open a second club.',
  'branches.reader': 'Branch',
  'branches.none': 'No branch',
  'branches.field': 'Branch',
  'branches.validAt': 'Valid at',
  'branches.everyBranch': 'Every branch',
  'branches.validAtHint': 'Pick the branches this plan opens. A card at any other branch is refused at the door.',
  'plans.validAt': 'Valid at {branches}',
  'staff.branchesTitle': 'Where {name} works',
  'staff.branchesHint': 'They see and act only at these branches. Every branch leaves them unrestricted; owners and admins always work everywhere.',
  'staff.branchesSaved': 'Branches saved',
  'staff.inviteBranches': 'Works at',
  'staff.inviteBranchesHint': 'Choose at least one branch. They see and act only at the branches chosen.',
  'staff.branchRequired': 'Choose at least one branch',
  'staff.worksEverywhere': 'Owners, admins, gym general managers and HR managers work at every branch.',
  'staff.invitedBranches': 'Branches',
  'shift.at': 'at {branch}',
  'dailyReport.dateAtBranch': '{date} · {branch}',
  'dailyReport.branchNote': 'Money taken at {branch}: its desk, drawer and bar. Online payments are taken at no branch, so they show only under All branches.',
  'rooms.title': 'Rooms',
  'rooms.description': 'The rooms classes happen in, per branch. Weekly slots and sessions pick their room from this list.',
  'rooms.empty': 'No rooms yet. Add the first one below.',
  'rooms.newName': 'Room name',
  'rooms.add': 'Add room',
  'rooms.added': 'Room added',
  'rooms.renamed': 'Room renamed',
  'rooms.removed': 'Room removed',
  'rooms.exists': 'This branch already has a room with that name',
  'rooms.rename': 'Rename {name}',
  'rooms.remove': 'Remove {name}',
  'rooms.moveUp': 'Move {name} up',
  'rooms.moveDown': 'Move {name} down',
  'rooms.removeTitle': 'Remove {name}?',
  'rooms.removeDescription': 'It leaves the room lists. Slots and sessions already in it keep it.',
};

export const ka: Record<keyof typeof en, string> = {
  'branches.switch': 'ფილიალი',
  'branches.all': 'ყველა ფილიალი',
  'branches.tab': 'ფილიალები',
  'branches.title': 'ფილიალები',
  'branches.description':
    'ადგილები, სადაც თქვენი დარბაზი მუშაობს. წევრები, აბონემენტები და ბალანსები საერთოა; კარები, მიმღები და ბარი ფილიალს ეკუთვნის.',
  'branches.name': 'სახელი',
  'branches.nameGeorgian': 'სახელი ქართულად',
  'branches.nameGeorgianHint': 'ჩანს ვებსაიტის ქართულ ვერსიაზე. თუ ცარიელია, ჩანს სახელი.',
  'branches.address': 'მისამართი',
  'branches.city': 'ქალაქი',
  'branches.phone': 'ტელეფონი',
  'branches.sortOrder': 'რიგი',
  'branches.readerCount.one': '{count} წამკითხველი',
  'branches.readerCount.other': '{count} წამკითხველი',
  'branches.primary': 'მთავარი',
  'branches.archived': 'დაარქივებული',
  'branches.add': 'ფილიალის დამატება',
  'branches.addTitle': 'ახალი ფილიალი',
  'branches.editTitle': '{name} — რედაქტირება',
  'branches.save': 'შენახვა',
  'branches.makePrimary': 'მთავრად მონიშვნა',
  'branches.archive': 'დაარქივება',
  'branches.restore': 'აღდგენა',
  'branches.showArchived': 'დაარქივებული ფილიალების ჩვენება',
  'branches.created': 'ფილიალი დაემატა',
  'branches.updated': 'ფილიალი შენახულია',
  'branches.primaryUpdated': 'მთავარი ფილიალი შეიცვალა',
  'branches.archivedDone': 'ფილიალი დაარქივდა',
  'branches.restoredDone': 'ფილიალი აღდგა',
  'branches.archiveTitle': 'დავაარქივოთ {name}?',
  'branches.archiveBody':
    'ის გაქრება ფილიალების გადამრთველიდან და ახალი არჩევანიდან. ისტორია შენარჩუნდება.',
  'branches.primaryHint':
    'მთავარ ფილიალს ეკუთვნის ყველაფერი, რასაც ფილიალი არ აქვს მითითებული. მისი დაარქივება შეუძლებელია.',
  'branches.single': 'თქვენს დარბაზს ერთი ფილიალი აქვს. დაამატეთ მეორე, როცა ახალ კლუბს გახსნით.',
  'branches.reader': 'ფილიალი',
  'branches.none': 'ფილიალის გარეშე',
  'branches.field': 'ფილიალი',
  'branches.validAt': 'მოქმედებს',
  'branches.everyBranch': 'ყველა ფილიალში',
  'branches.validAtHint': 'აირჩიეთ ფილიალები, სადაც ეს აბონემენტი მოქმედებს. სხვა ფილიალის კარი ბარათს არ გაატარებს.',
  'plans.validAt': 'მოქმედებს: {branches}',
  'staff.branchesTitle': 'სად მუშაობს {name}',
  'staff.branchesHint': 'ხედავს და მოქმედებს მხოლოდ ამ ფილიალებში. „ყველა ფილიალი“ შეზღუდვას ხსნის; მფლობელი და ადმინისტრატორი ყოველთვის ყველგან მუშაობენ.',
  'staff.branchesSaved': 'ფილიალები შენახულია',
  'staff.inviteBranches': 'სად მუშაობს',
  'staff.inviteBranchesHint': 'აირჩიეთ ერთი ფილიალი მაინც. ხედავს და მოქმედებს მხოლოდ არჩეულ ფილიალებში.',
  'staff.branchRequired': 'აირჩიეთ ერთი ფილიალი მაინც',
  'staff.worksEverywhere': 'მფლობელი, ადმინისტრატორი, დარბაზის გენერალური მენეჯერი და HR მენეჯერი ყველა ფილიალში მუშაობენ.',
  'staff.invitedBranches': 'ფილიალები',
  'shift.at': '{branch}',
  'dailyReport.dateAtBranch': '{date} · {branch}',
  'dailyReport.branchNote': '{branch}-ში მიღებული თანხა: მისი მიღება, სალარო და ბარი. ონლაინ გადახდები არცერთ ფილიალს არ ეკუთვნის, ამიტომ მხოლოდ „ყველა ფილიალში“ ჩანს.',
  'rooms.title': 'ოთახები',
  'rooms.description': 'ოთახები, სადაც ვარჯიშები ტარდება, ფილიალების მიხედვით. კვირის სლოტები და სესიები ოთახს ამ სიიდან ირჩევენ.',
  'rooms.empty': 'ოთახები ჯერ არ არის. დაამატეთ პირველი ქვემოთ.',
  'rooms.newName': 'ოთახის სახელი',
  'rooms.add': 'ოთახის დამატება',
  'rooms.added': 'ოთახი დაემატა',
  'rooms.renamed': 'ოთახს სახელი შეეცვალა',
  'rooms.removed': 'ოთახი წაიშალა',
  'rooms.exists': 'ამ ფილიალს ამ სახელით ოთახი უკვე აქვს',
  'rooms.rename': '{name}: სახელის შეცვლა',
  'rooms.remove': '{name}: წაშლა',
  'rooms.moveUp': '{name}: ზემოთ',
  'rooms.moveDown': '{name}: ქვემოთ',
  'rooms.removeTitle': 'წავშალოთ {name}?',
  'rooms.removeDescription': 'ოთახი სიებიდან გაქრება. სლოტები და სესიები, რომლებიც მასში უკვე არის, მას შეინარჩუნებენ.',
};
